import { IconButton } from '@fluentui/react';
import AssetSelectorPanel from '../issues/AssetSelectorPanel';
import { useBoolean } from '@fluentui/react-hooks';
import { IAsset } from '../../services/assetServices';
import { Field, Input } from '@fluentui/react-components';

export interface IAssetSelectorParams {
  assetName?: string;
  assetId?: number;
  disabled: boolean;
  onSelected: (asset: IAsset) => void;
  errorMessage?: string;
  label?: string;
  selectorPanelHeaderText?: string;
}

const AssetSelector = (props: IAssetSelectorParams) => {
  const [
    isAssetSelectorOpen,
    { setTrue: showAssetSelector, setFalse: hideAssetSelector },
  ] = useBoolean(false);

  return (
    <>
      <Field label={props.label ?? 'Asset'} orientation="horizontal">
        <div
          style={{
            position: 'relative',
            display: 'inline-block',
            width: '100%',
          }}
        >
          <Input
            disabled={props.disabled}
            style={{ width: '100%' }}
            value={props?.assetName || ''}
            readOnly
            onClick={showAssetSelector}
          />
          {props.disabled ? null : (
            <IconButton
              iconProps={{ iconName: 'Search' }}
              styles={{
                root: {
                  position: 'absolute',
                  top: 2,
                  right: 2,
                  height: 28,
                },
              }}
              onClick={() => showAssetSelector()}
            />
          )}
        </div>
      </Field>
      <AssetSelectorPanel
        isOpen={isAssetSelectorOpen}
        hideAssetSelector={hideAssetSelector}
        onAssetLinkClick={(
          assetId: number,
          assetCode: string,
          assetName: string,
          assetUuid: string
        ) => {
          props.onSelected({
            id: assetId,
            code: assetCode,
            name: assetName,
            uuid: assetUuid,
            category: '',
            categoryId: 0,
          });
        }}
        selectorPanelHeaderText={props.selectorPanelHeaderText}
        //   onAssetLinkClick={props.onSelected}
      />
    </>
  );
};

export default AssetSelector;
